import { Routes, Route, Link } from "react-router-dom";
import { motion } from "framer-motion";
import Home from "./Components/Home/Home";
import Skills from "./Components/Skills/Skills";
import Projects from "./Components/Projects/Projects";
import Error from "./Components/Error";
import { useState } from "react";
export default function Nav() {
  var [element, setElement] = useState(false);
  var arr = [
    { x: "/", y: "Home" },
    { x: "/skills", y: "Skills" },
    { x: "/projects", y: "Projects" }
  ];

  var delay = 0.4;
  var variant = {
    initial: {
      y: -100,
      scale: 0.4
    },
    animate: {
      y: 0,
      scale: 1,
      transition: {
        type: "spring",
        stiffness: 300
      }
    }
  };
  var variant3 = {
    initial: {
      y: 0,
      scale: 1
    },
    animate: {
      y: -100,
      scale: 0,
      transition: {
        type: "spring",
        stiffness: 300
      }
    }
  };
  var variant2 = {
    initial: {
      x: -10000,
      scale: 0.4,
      opacity: 0.4
    },
    final: {
      x: 0,
      scale: 1,
      opacity: 2
    }
  };
  return (
    <div className="nav-container">
      <motion.div
        variants={variant}
        initial="initial"
        animate="animate"
        className="nav"
      >
        <h1>PortFolio</h1>
        <div className="links">
          {arr.map((item) => {
            delay = delay + 0.4;
            return (
              <Link to={item.x}>
                <motion.li
                  key={delay}
                  variants={variant2}
                  initial="initial"
                  animate="final"
                  transition={{ delay: delay }}
                >
                  {item.y}
                </motion.li>
              </Link>
            );
          })}

          <button onClick={() => setElement(!element)}>
            <div></div>
            <div></div>
            <div></div>
          </button>
        </div>
      </motion.div>
      {element ? (
        <motion.div
          className="responsive"
          variants={variant}
          initial="initial"
          animate="animate"
        >
          {arr.map((item) => {
            delay = delay + 0.5;
            return (
              <Link to={item.x}>
                <hr style={{ border: "solid white 2px" }} />
                <motion.li
                  key={delay + 0.1}
                  variants={variant2}
                  initial="initial"
                  animate="final"
                  transition={{ delay: delay }}
                >
                  {item.y}
                </motion.li>
              </Link>
            );
          })}
        </motion.div>
      ) : (
        <motion.div
          className="responsive"
          variants={variant3}
          initial="initial"
          animate="animate"
        >
          {null}
        </motion.div>
      )}
      <div className="elements"></div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/skills" element={<Skills />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </div>
  );
}
